export const useLogOut = () => {
  return () => {
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = `/auth`;
  };
};

export const getAssetType = ({ name }) => {
  const extension = name?.split(".")?.pop()?.toLowerCase();

  return extension;
};

export const formatToTimestamp = (date) => {
  const d = new Date(date);
  return d.toISOString().replace("Z", "") + "Z";
};

export const formatDate = (date, fallback = "") => {
  if (!date) return fallback;

  return new Date(date).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(",")[1]);
    reader.onerror = (error) => reject(error);
  });
};

export const getNumber = (str) => {
  const arr = str.split("");
  const out = [];
  let hasDecimal = false;

  for (let i = 0; i < arr.length; i++) {
    if (!isNaN(arr[i]) || (arr[i] === "." && !hasDecimal)) {
      if (arr[i] === ".") {
        hasDecimal = true;
      }
      out.push(arr[i]);
    }
  }

  return out.join("");
};

export const formatNumberWithCommas = (numStr) => {
  if (numStr === null || numStr === undefined || numStr === "") return "";
  const str = String(numStr);
  const [integerPart = "", decimalPart] = str.split(".");
  // remove any existing commas before parsing
  const integerNumeric = parseInt(integerPart.replace(/,/g, ""), 10);
  const formattedInteger = Number.isNaN(integerNumeric)
    ? "0"
    : integerNumeric.toLocaleString();

  return decimalPart !== undefined && decimalPart !== ""
    ? `${formattedInteger}.${decimalPart}`
    : formattedInteger;
};

export const formatCreationDate = (timestamp) => {
  if (!timestamp) return null;
  const date = new Date(timestamp);
  return date.toISOString();
};

export const formatTime = (dateString) => {
  const date = new Date(dateString);
  const options = {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };
  return date.toLocaleString("en-US", options);
};

export const convertTime = (timeString) => {
  if (typeof timeString !== "string") {
    console.error("Invalid input: timeString must be a string");
    return null;
  }
  const now = new Date();
  const [time, modifier] = timeString.toLowerCase().split(/(am|pm)/);
  let [hours, minutes] = time.trim().split(":").map(Number);
  if (modifier === "pm" && hours !== 12) hours += 12;
  if (modifier === "am" && hours === 12) hours = 0;
  now.setHours(hours);
  now.setMinutes(minutes);
  now.setSeconds(0);
  now.setMilliseconds(0);
  return now.toISOString();
};

export function formatToShortDate(dateString) {
  const date = new Date(dateString);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
}

export const downloadDocument = async (url, filename) => {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error("Network response was not ok");
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename || "document";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Revoke the blob URL to free up memory
    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Download failed:", error);
    // Fallback to opening in new tab
    window.open(url, "_blank");
  }
};

export function viewDocument(url, options = {}) {
  const { width = 800, height = 600, position = "center" } = options;

  const left = (window.screen.width - width) / 2;
  const top = (window.screen.height - height) / 2;

  const features = `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`;

  const newWindow = window.open(url, "_blank", features);

  if (newWindow) {
    newWindow.focus();
  } else {
    console.warn("Popup was blocked by browser, opening in new tab instead");
    window.open(url, "_blank");
  }

  return newWindow;
}

export function convertToTime(isoString) {
  const date = new Date(isoString);
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12;
  const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
  return `${hours}:${formattedMinutes} ${ampm}`;
}

export const formatPermissionName = (permission) => {
  const spaced = permission.replace(/([a-z])([A-Z])/g, "$1 $2");
  return spaced;
};

export function WeekStartDate() {
  const now = new Date();
  const dayOfWeek = now.getDay();
  const diffToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
  const monday = new Date(now);
  monday.setDate(now.getDate() - diffToMonday);
  monday.setHours(0, 0, 0, 0);
  return monday.toISOString();
}

export function WeekEndDate() {
  const now = new Date();
  const dayOfWeek = now.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6
  const diffToFriday = (5 + 7 - (dayOfWeek === 0 ? 7 : dayOfWeek)) % 7; // Days until Friday
  const friday = new Date(now);
  friday.setDate(now.getDate() + diffToFriday);
  friday.setHours(23, 59, 59, 999);
  return friday.toISOString();
}

// Filter Helper

export const applyFilters = (data = [], filtArray = [], fieldMap = {}) => {
  if (!Array.isArray(data)) return [];

  let filtered = [...data];

  filtArray.forEach((filter) => {
    const field = fieldMap[filter.title];
    if (!field) return;

    if (field === "creationDate") {
      const formatted = formatDate(filter.creationDate);
      filtered = filtered.filter(
        (item) => formatDate(item.creationDate) === formatted,
      );
    } else {
      filtered = filtered.filter((item) =>
        String(item[field])
          .toLowerCase()
          .includes(String(filter.filter).toLowerCase()),
      );
    }
  });

  return filtered;
};

// Filter Helper 2

export const filterRows = (rows = [], filters = []) =>
  rows.filter((row) =>
    filters.every(({ field, value }) => {
      const filterVal = value?.toString().toLowerCase() ?? "";
      const rowVal = row[field]?.toString().toLowerCase() ?? "";
      return rowVal.includes(filterVal);
    }),
  );

export function getDateRanges() {
  const now = new Date();

  // Helper function to format date as YYYY-MM-DD
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Day start and end (today)
  const dayStartDate = formatDate(now);
  const dayEndDate = formatDate(now);

  // Week start (Monday) and end (Friday)
  const weekStart = new Date(now);
  weekStart.setDate(now.getDate() - ((now.getDay() + 6) % 7)); // Monday

  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekStart.getDate() + 4); // Friday

  const weekStartDate = formatDate(weekStart);
  const weekEndDate = formatDate(weekEnd);

  // Month start and end
  const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
  const monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  const monthStartDate = formatDate(monthStart);
  const monthEndDate = formatDate(monthEnd);

  return {
    dayStartDate,
    dayEndDate,
    weekStartDate,
    weekEndDate,
    monthStartDate,
    monthEndDate,
  };
}
